export default (queryConditions, totalCount) => {
  //直接点击分页的查询容错,当页码与页容量与总数量不符时返回
  if (
    queryConditions.PageIndex > 1 &&
    Math.floor(
      Number(totalCount) / Number(queryConditions.PageSize)
    ) <
    queryConditions.PageIndex - 1
  ) {
    queryConditions.PageIndex = Math.ceil(
      Number(totalCount) / Number(queryConditions.PageSize)
    );
    return true;
  } else {
    return false;
  }
}


//////////////////
// WEBPACK FOOTER
// ./utils/paginationNewUtils.js
// module id = null
// module chunks = 